import {create, destroy} from '../../../lib/instances'

const E = {
  SHOW_SUMMARY: {
    event: 'playcard.reload.show-summary',
    instanceName: 'playcard-reload-loyalty-status',
    create: {
      component: 're-loyalty-status',
      componentOptions: {
        classes: false,
        component: {
          attributes: {}
        }
      },
      target: {
        targetSelector: '.re-reload-card .re-reload-card-summary',
        root: '.playcard-reload-loyalty-status',
        element: '<div class="playcard-reload-loyalty-status"></div>',
        method: 'prependTo',
      }
    }
  }
}

export default (Bus) => {
  Bus.$on(E.SHOW_SUMMARY.event, async (show, vm) => {
    if (show && vm.authenticated) {
      destroy(E.SHOW_SUMMARY.instanceName)
      await create(E.SHOW_SUMMARY.create, E.SHOW_SUMMARY.instanceName)
    } else {
      destroy(E.SHOW_SUMMARY.instanceName)
    }
  })
}

